'use strict'; // Helper class to rewrite nodes with specific mime type

var _classCallCheck = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/runner/work/smaug/smaug/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var Transform = require('stream').Transform;

var libmime = require('libmime');
/**
 * Really bad "stream" transform to parse format=flowed content
 *
 * @constructor
 * @param {String} delSp True if delsp option was used
 */


var FlowedDecoder =
/*#__PURE__*/
function (_Transform) {
  _inherits(FlowedDecoder, _Transform);

  function FlowedDecoder(config) {
    var _this;

    _classCallCheck(this, FlowedDecoder);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FlowedDecoder).call(this));
    _this.config = config || {};
    _this.chunks = [];
    _this.chunklen = 0;
    _this.libmime = new libmime.Libmime({
      Iconv: config.Iconv
    });
    return _this;
  }

  _createClass(FlowedDecoder, [{
    key: "_transform",
    value: function _transform(chunk, encoding, callback) {
      if (!chunk || !chunk.length) {
        return callback();
      }

      if (!encoding !== 'buffer') {
        chunk = Buffer.from(chunk, encoding);
      }

      this.chunks.push(chunk);
      this.chunklen += chunk.length;
      callback();
    }
  }, {
    key: "_flush",
    value: function _flush(callback) {
      if (this.chunklen) {
        var currentBody = Buffer.concat(this.chunks, this.chunklen);

        if (this.config.encoding === 'base64') {
          currentBody = Buffer.from(currentBody.toString('binary'), 'base64');
        }

        var content = this.libmime.decodeFlowed(currentBody.toString('binary'), this.config.delSp);
        this.push(Buffer.from(content, 'binary'));
      }

      return callback();
    }
  }]);

  return FlowedDecoder;
}(Transform);

module.exports = FlowedDecoder;